export default function Comments({ data }) {
    const sortedData = data.sort((a, b) => new Date(b.time) - new Date(a.time));
    return (
        <div className='termsDisDiv'>
            <div className='termsDisPoints'>
                <ul>
                    {sortedData?.map((comment, index) => {
                        return (
                            <li key={index} className='termsDisText'>
                                ➡️ {comment.comment}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}
